<template>
  <div class="attachment-block">
    <h3 class="attachment-block__title">{{ $t('view.flow.block.attachment.title') }}</h3>
    <div class="attachment-block__wrapper">
      <sel
        :label="$t('view.flow.block.attachment.target')"
        v-model="val.attachmentUuid"
        class="attachment-block__select"
        @input="onInput"
      >
        <option
          v-for="attachment in $store.state.attachments"
          :key="attachment.id"
          :value="attachment.uuid"
        >{{ attachment.name }}</option>
      </sel>
      <div
        v-if="val.attachmentUuid && ['.jpg', '.jpeg', '.png', '.gif'].indexOf($store.state.attachments[val.attachmentUuid].extension) !== -1"
        class="attachment-block__preview"
      >
        <img :src="$store.state.attachments[val.attachmentUuid].url" alt="Attachment preview.">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      val: null
    }
  },
  props: ['value', 'blockId'],
  created () {
    this.val = this.value
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.attachment-block {
  @include flowElementShadow();
  width: 30%;
  min-width: 380px;
  background-color: white;
  border-radius: 7px;
  padding: 1px 14px 10px 14px;
  text-align: left;

  &__title {
    margin: 9px 0 12px 0;
    text-align: left;
  }

  &__wrapper {
    @include alignedFlex(flex-start);
    width: 100%;
    text-align: center;
    padding: 0 10px;
  }

  &__select {
    margin-top: 10px;
    width: 75%;
    margin-right: 25px;
  }

  &__preview {
    @include alignedFlex();
    width: 60px;
    height: 60px;
    background: $bgLightGrey;

    & > img {
      border-radius: 3px;
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
